// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-item-customer-locales {\n  margin-bottom: 24px;\n}\n.form-item-customer-locales .ant-transfer {\n  width: 100%;\n  height: 300px;\n  max-width: 700px;\n}\n.form-item-customer-locales .ant-transfer-list {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
